import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const ViewProgramWrapper = styled.div`
  padding-top: 6px;
  color: ${COLORS.cirrus_black};

  .fee-tax-details-accordion {
    margin-top: 16px;
    margin-bottom: 32px;
  }
  .fee-tax-details-accordion:last-child {
    margin-bottom: 16px;
  }
`;
